/*
 * @Descripttion: 
 * @version: 
 * @Author: Jiang ShareFont
 * @Date: 2023-04-08 13:40:47
 * @LastEditors: 
 * @LastEditTime: 2024-05-25 11:30:08
 */
export function setCookie(name, value, expire, domain) {
  var date = new Date()
  if (expire) {
    date.setSeconds(date.getSeconds() + expire)
    document.cookie = name + '=' + escape(value) + '; expires=' + date.toGMTString() + ';' + domain
  } else {
    document.cookie = name + '=' + escape(value) + ';' + domain
  }
}
export function getCookie(name) {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      let end = document.cookie.indexOf(';', start)
      if (end === -1) end = document.cookie.length
      return unescape(document.cookie.substring(start, end))
    }
  }
  return ''
}
export function delCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'

}



// WEBPACK FOOTER //
// ./src/common/js/cookie.js